import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import classes from '../../index.module.scss'
import Items from './Items'

const Information = ({
  setting,
  setValue,
  informationSetting,
  isFirstLevelInline,
  isMapTitleApi,
  id,
}) => {
  const { renderCustomInformation } = informationSetting[0]

  return (
    <Element className={classes.setting} style={{ background: '#F3F3F3' }}>
      <div className={classes.label}>
        <Translate value="financialAnalysis.INFORMATION" />
      </div>
      <div>
        {!!renderCustomInformation ? (
          renderCustomInformation()
        ) : (
          <i>
            <Translate value="dynamicReport.PANEL_SETTING_NOTE" />
          </i>
        )}
      </div>
      <Items
        items={informationSetting}
        setting={setting}
        setValue={setValue}
        isInline={isFirstLevelInline}
        isFirstLevel
        isMapTitleApi={isMapTitleApi}
        id={id}
      />
    </Element>
  )
}

Information.propTypes = {
  setting: PropTypes.object,
  setValue: PropTypes.func.isRequired,
  informationSetting: PropTypes.array.isRequired,
  isFirstLevelInline: PropTypes.bool,
  isMapTitleApi: PropTypes.bool,
}

Information.defaultProps = {
  setting: {},
  isFirstLevelInline: false,
}

export default Information
